__turbopack_context__.v({
  "attributes": "a8T73G_attributes",
  "content": "a8T73G_content",
  "control": "a8T73G_control",
  "description": "a8T73G_description",
  "header": "a8T73G_header",
  "room": "a8T73G_room",
  "sheetContent": "a8T73G_sheetContent",
  "showMoreButton": "a8T73G_showMoreButton",
  "trailing": "a8T73G_trailing",
});
